<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="clearfix m-3" v-if="!showOnly">
                    <a class="btn btn-brand pull-right"
                       @click.prEvent="createLocation">{{ uLang('app.add_type', {type: lang('app.location')}) }}</a>
                </div>

                <rea-loader :loading="loading"></rea-loader>
                <table class="table table-striped">
                    <thead>
                    <th>{{ uLang('app.name') }}</th>
                    <th>{{ uLang('app.address') }}</th>
                    <th>{{ uLang('app.actions') }}</th>
                    </thead>
                    <tbody>
                        <tr v-for="location in locations" @click.prevent="showLocationDetails(location.id)" class="pointer">
                            <td>{{ location.name }}</td>
                            <td>{{ location.addresses[0].street }} {{ location.addresses[0].house_number }}, {{ location.addresses[0].zipcode }} {{ location.addresses[0].city }}</td>
                            <td>
                                <i class="fa fa-edit fa-lg pointer" @click.stop.prevent="editLocation(location.id)" :title="uLang('app.edit_type', { type: lang('app.location') })"></i>
                                <i class="fa fa-trash fa-lg pointer" @click.stop.prevent="deleteLocation(location.id)" :title="uLang('app.delete_type', { type: lang('app.location') })"></i>
                            </td>
                        </tr>
                        <tr v-if="loading === false && !locations.length">
                            <td colspan="3" class="text-center">{{ uLang('app.there_are_no_locations_registered') }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <b-modal id="add_location_modal" :hideFooter="true" :title="locationModalTitle" ref="location_modal" size="md"
                 v-if="!showOnly">
            <location-form @locationStored="addLocation" :overrideEndpoint="overrideStoreEndpoint"
                           :id="currentEditingId" ref="location_form"/>
        </b-modal>
        <modal-location :resource="resource" :resource-id="resourceId" ref="location_details_modal"/>
    </div>
</template>

<script>
    import { event as Event }  from '~/events';
    import TableLocations from '~/components/tables/location/table';
    import LocationForm from '~/components/forms/location/form';
    import { ReaLoader } from '~/components/helpers'
    import DestroyAlert from '~/Swals/DestroyAlert'
    import SuccessAlert from '~/Swals/SuccessAlert'

    export default {
        name: "locations-tab",

        components: {
            'table-locations': TableLocations,
            'location-form': LocationForm,
            'rea-loader': ReaLoader,
        },

        props: {
            resource: {
                default: null
            },
            resourceId: {
                required: true,
            },
            showOnly: {
                type: Boolean,
                default: false
            }
        },

        data(){
            return {
                loading: true,
                locations: [],
                locationModalTitle: '',
                currentEditingId: null,
            };
        },

        created() {
            Event.init();
            this.retrieveLocations();

            Event.on('editLocation', (id) => {
                this.editLocation(id);
            });

            Event.on('showLocation', (id) => {
                this.showLocationDetails(id);
            });
        },

        methods: {
            async retrieveLocations() {
                this.loading = true;
                const {data} = await window.axios.get(route('resource.locations.index', {
                    resource: this.resource,
                    resource_id: this.resourceId
                }));

                this.locations = data;
                this.loading = false;
            },

            createLocation() {
                this.locationModalTitle = this.uLang('app.create_entity', { entity: this.uLang('app.location')});
                this.currentEditingId = null;
                this.$refs.location_form.form.reset();
                this.$refs.location_modal.show();
            },

            addLocation(location) {
                this.$refs.location_modal.hide();
                this.retrieveLocations();
            },

            editLocation(id){
                this.currentEditingId = id;
                this.locationModalTitle = this.uLang('app.edit_entity', { entity: this.lang('app.location')});
                this.$nextTick(() => {
                    this.$refs.location_form.retrieve();
                    this.$refs.location_modal.show();
                });
            },

            async deleteLocation(id){
                new DestroyAlert({ entity: this.lang('app.action_document') }).show().then(async () => {
                    window.axios.delete(route('resource.locations.destroy', {
                        resource: this.resource,
                        resource_id: this.resourceId,
                        location: id,
                    }))
                        .then((response) => {
                            this.retrieveLocations();
                            new SuccessAlert({title: this.data.name, text: this.uLang('app.entity_removed', { entity: this.lang('app.location') })}).show();
                        });
                });
            },

            showLocationDetails(id){
                this.$refs.location_details_modal.retrieveLocation(id);
            }
        },

        computed: {
            overrideStoreEndpoint() {
                return route('resource.locations.store', {
                    resource: this.resource,
                    resource_id: this.resourceId,
                });
            },
        },
    }
</script>
